import React from 'react';
import PropTypes from 'prop-types';
import maxBy from 'lodash/maxBy';
import get from 'lodash/get';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
} from 'recharts';

import { CHART_FULL_HEIGHT } from './helper';

const CustomTick = ({ x, y, payload }) => {
  const items = get(payload, 'value', '').split('\n');
  const BAR_WIDTH = 50;
  const PADDING_Y_AXIS = 26;

  const getOffsetTick = (text) => {
    const wordWidth = 6 * text.length;
    const freeSpace = BAR_WIDTH - wordWidth;
    return PADDING_Y_AXIS - freeSpace / 2;
  };

  return (
    <g transform={`translate(${x},${y})`}>
      { items.map((text, cIndex) => (
          <text
            x={getOffsetTick(text)}
            y={15 * cIndex}
            dy={10}
            textAnchor="end"
            fill="#242424"
            fontSize={14}
            fontStyle="italic"
          >
            {text}
          </text>
        ))}
    </g>
  );
};

const ChartGraph = (chartData, height) => {
  let highDomainLimit = 40;
  const maxData = maxBy(chartData, 'studentCount');
  if (maxData) {
    highDomainLimit = Number(maxData.studentCount);
  }

  return (
    <ResponsiveContainer height={height}>
      <BarChart
        data={chartData}
        margin={{ top: 20, right: 0, left: -20, bottom: 0 }}
      >
        <Bar
          dataKey="studentCount"
          fill="var(--prs-c-info-800)"
          minPointSize={0}
          label={{
            value: 'studentCount',
            position: 'top',
            fontFamily: 'Source Sans Pro',
            fontSize: 14,
            fill: '#242424'
          }}
        />
        <XAxis
          dataKey="label"
          interval={0}
          tickLine={false}
          tick={CustomTick}
          height={40}
        />
        <YAxis
          dataKey="studentCount"
          domain={[0, highDomainLimit]}
          label={{ value: 'total students',
            angle: -90,
            position: 'center',
            fontSize: 14,
            fontFamily: 'Source Sans Pro',
            fontStyle: 'italic',
            fill: '#242424',
          }}
          tick={false}
          axisLine={false}
          tickLine={false}
        />
        <CartesianGrid vertical={false} horizontal={false} />
      </BarChart>
    </ResponsiveContainer>
  );
};

function ExpectiationScaleChart({ chartData = [], isMobileXS }) {
  const isChartDataEmpty = chartData.length === 0;
  if (isChartDataEmpty) {
    return null;
  }

  return ChartGraph(chartData, isMobileXS ? 200 : CHART_FULL_HEIGHT);
}

ExpectiationScaleChart.propTypes = {
  chartData: PropTypes.array.isRequired,
  isMobileXS: PropTypes.bool,
};

export default ExpectiationScaleChart;
